import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import TaxonomyCodeIcon from "../../../assets/images/svg-icons-material-io/link_FILL0_wght400_GRAD0_opsz48.svg";
import MonitorIcon from "../../../assets/images/svg-icons-material-io/screenshot_monitor_FILL0_wght400_GRAD0_opsz48.svg";
import BulkUploadTemplate from "../../../assets/images/bulkUploadimg.png";
import { Link } from "react-router-dom";
import CallAPI from "../../../services/apiCalls";
import useUserStore from "../../../utils/storeApp";
import $ from "jquery";
import fileDownload from "js-file-download";

const obj = {
  VendorId: 0,
  OrganizationId: 0,
  OrganizationName: "",
  UploadOption: "Add",
  UserSubmitFile: "",
  isSendNotification: false,
};
const FormUserUpload = () => {
  const navigate = useNavigate();
  const { userToken, sharedObject, SetSharedObject, userRole, userSession } =
    useUserStore((state) => ({
      userToken: state.userToken,
      SetSharedObject: state.SetSharedObject,
      sharedObject: state.sharedObject,
      userRole: state.userRole,
      userSession: state.userSession,
    }));
  const [processing, SetProcessing] = useState(false);
  const [submitFlag, SetSubmitFlag] = useState(false);
  const [errFlag, SetErrFlag] = useState(false);
  const [answers, setAnswers] = useState(obj);
  const [orgObj, SetOrgObj] = useState([]);
  const [custObject, SetCustObject] = useState([]);
  const [errCreateMsg, SetErrCreateMsg] = useState(false);
  const [errMsg, SetErrMsg] = useState(false);
  const [successFlag, SetSuccessFlag] = useState(false);
  const [customerErrorFlag, setCustomerErrorFlag] = useState(false);

  useEffect(() => {
      const temp = [];
    for (let el of sharedObject.vendorsObj) {
      el.show = true;
      temp.push(el);
    }
    SetCustObject(temp);
    SetSharedObject("specialties", {});
    SetSubmitFlag(false);
    setCustomerErrorFlag(false);
    if (userRole !== "SES ADMINISTRATOR") {
      const temp = [];
      //CustomerIdSet(userSession.vendor_id);
      for (let el of sharedObject.getOrgsObj) {
        el.show = true;
        temp.push(el);
      }
      SetOrgObj(temp);
      //getOrgs(userSession.org_id);
    }
  }, []);

  const setAnswer = async (questionId, answer, chck) => {
    await setAnswers({ ...answers, [questionId]: answer });
  };
  const CustomerIdSet = async (el) => {
    if (el === "") {
      SetOrgObj([]);
      return;
    }
    SetProcessing(true);
    let call = "/users/GetOrgsByCustID?vendorID=" + parseInt(el);
    const res = await CallAPI(call, false, "get", userToken);
    await SetSharedObject("ResponseCode", res.code);
    if (res.status === "SUCCESS") {
      const temp = [];
      for (let el of res.data.data) {
        el.show = true;
        temp.push(el);
      }
      SetOrgObj(temp);
      SetProcessing(false);
    } else if (res.status === "SERVERERROR") {
      SetProcessing(true);
    }
    };

    const getOrgs = async (org, vendor) => {
        SetProcessing(true);
        let model = { ParentOrganizationId: org };
        let call = "/organization/OrgSearchEngine";
        const res = await CallAPI(call, model, "post", userToken);
        
        if (res.status === "SUCCESS") {
            const temp = res.data.data;
            const result = [];
            for (var i = 0; i < temp.length; i++) {
                var arr = { id: temp[i].id, name: temp[i].name, show: true };
                result.push(arr);
            }
            SetProcessing(false);
            SetOrgObj(result);
        } else if (res.status === "SERVERERROR") {
            SetProcessing(true);
            return [];
        }
    }
  const filterVendors = (val) => {
    const tmp = [];
    if (val.length > 1) {
      custObject?.map((el) => {
        let elem = el.name;
        if (elem.toLowerCase().includes(val.toLowerCase())) {
          el.show = true;
        } else {
          el.show = false;
        }
        tmp.push(el);
      });
    } else {
      custObject?.map((el) => {
        el.show = true;
        tmp.push(el);
      });
    }
    SetCustObject(tmp);
  };
  const filterOrganiations = (val) => {
    const tmp = [];
    if (val.length > 1) {
      orgObj?.map((el) => {
        let elem = el.name;
        if (elem.toLowerCase().includes(val.toLowerCase())) {
          el.show = true;
        } else {
          el.show = false;
        }
        tmp.push(el);
      });
    } else {
      orgObj?.map((el) => {
        el.show = true;
        tmp.push(el);
      });
    }
    SetOrgObj(tmp);
  };

  const downTemplate = async (url) => {
    SetProcessing(true);
    const res = await CallAPI(url, false, "get", userToken);
    await SetSharedObject("ResponseCode", res.code);
    if (res.status === "SUCCESS") {
      let fileName = "SescsvBulkUploadTemplate.csv";
      fileDownload(res.data, fileName);
      SetProcessing(false);
    } else if (res.status === "SERVERERROR") {
      SetProcessing(true);
    }
  };
  const UploadFile = async () => {
    SetSuccessFlag(false);
    SetSubmitFlag(true);
    if (!answers?.UserSubmitFile) {
      document.getElementById("UserSubmitFile").scrollIntoView();
      document.getElementById("UserSubmitFile").focus();
      return;
    } else if (!answers.OrganizationId) {
      document.getElementById("OrganizationId").scrollIntoView();
      document.getElementById("OrganizationId").focus();
      return;
    }
    SetProcessing(true);
    let url =
      "/users/UploadAssistRegistration?organizationId=" +
      answers.OrganizationId +
      "&isSendNotification=" +
      answers.isSendNotification +
      "&uploadOption=" +
      answers.UploadOption;
    const fileInput = document.querySelector('input[type="file"]');
    const file = fileInput.files[0];
    const bodyFormData = new FormData();
    bodyFormData.append("file", file, file.name);
    const res = await CallAPI(url, bodyFormData, "post", userToken, true);
    await SetSharedObject("ResponseCode", res.code);
    if (res.status === "SUCCESS") {
      SetProcessing(false);
      let dt = JSON.parse(res.data.data);
      SetSharedObject("UploadObj", dt);
      SetSharedObject("UploadFlag", "users");
      navigate("/upload-results");
    } else if (res.status === "VALIDATIONERROR") {
      let msg = JSON.parse(res.data);
      let str = "";
      if (typeof msg === "string") {
        str = msg;
      } else {
        str = "<div>";
        for (let el of msg) {
          str += `${el.Msg}`;
        }
        str += "</div>";
      }
      SetErrMsg(str);
      SetErrCreateMsg(true);
      SetProcessing(false);
    } else if (res.status === "SERVERERROR") {
      let msg = res.data;
      let str = "";
      if (typeof msg === "string") {
        str = msg;
      } else {
        str = "<div>";
        for (let el of msg) {
          str += `${el.Msg}`;
        }
        str += "</div>";
      }
      SetErrMsg(str);
      SetErrCreateMsg(true);
      SetProcessing(false);
    }
  };
  const triggerValidation = (el) => {
    var regex = new RegExp("(.*?).(csv)$");
    if (!regex.test(el.target.value.toLowerCase())) {
      SetErrFlag(true);
    } else {
      setAnswer("UserSubmitFile", el);
      SetErrFlag(false);
    }
  };
  const getDomain = (url) => {
    url = url.replace(/(https?:\/\/)?(www.)?/i, "");
    if (url.indexOf("/") !== -1) {
      return url.split("/")[0];
    }
    return url;
  };
  const openImg = () => {
    let url = getDomain(window.location.hostname);
    if (url === "localhost") {
      window.open(BulkUploadTemplate);
    } else {
      window.open(BulkUploadTemplate);
    }
  };
  return (
    <div className="FormUserUpload">
      <form className="sp-pad1">
        {/*Left Panel*/}
        <div className="left-panel-s1">
          {userRole !== "SES ADMINISTRATOR" ? null : (
            <div className="field-wrapper">
              <label for="customer">Customer</label>
              <span className="filter-container dg-clr">
                <input
                  className="form-control filter-sm"
                  type="search"
                  placeholder="Filter"
                  onChange={(el) => {
                    filterVendors(el.target.value);
                  }}
                />
              </span>
              <select
                className="form-control"
                size="5"
                id="VendorId"
                name="VendorId"
                onChange={(el) => {
                  CustomerIdSet(el.target.value);
                  setAnswer("VendorId", parseInt(el.target.value));
                }}
                value={answers?.VendorId}
              >
                <option value={0}>Select Customer</option>
                {custObject?.map((el) => {
                  if (el.show)
                    return (
                      <option key={el.id} value={el.id}>
                        {el.name}
                      </option>
                    );
                })}
              </select>
              {submitFlag && answers?.VendorId === 0 ? (
                <div className="alert alert-danger">Customer is required.</div>
              ) : null}
            </div>
          )}
          <div className="field-wrapper">
            <label for="Org"> Organization</label>
            {/* <i className="bi bi-asterisk rd-clr" aria-labelledby="Required" alt="asterik"></i>*/}
            <span className="filter-container dg-clr">
              <input
                className="form-control filter-sm"
                type="search"
                placeholder="Filter"
                onChange={(el) => filterOrganiations(el.target.value)}
              />
            </span>

            {orgObj.length > 0 ? (
              <select
                className="form-control"
                size="5"
                name="OrganizationId"
                id="OrganizationId"
                onChange={(el) => {
                  setAnswer("OrganizationId", parseInt(el.target.value));
                }}
                value={answers?.OrganizationId}
              >
                <option value={0}>Select Organization</option>
                {orgObj?.map((el) => {
                  if (el.show)
                    return (
                      <option key={el.id} value={`${el.id}`}>
                        {el.name}
                      </option>
                    );
                })}
              </select>
            ) : (
              <div className="watermark-wrapper">No Results</div>
            )}

            {/*Org list based on the customer*/}

            {answers?.OrganizationId === 0 && submitFlag ? (
              <div className="alert alert-danger">
                Organization is required.
              </div>
            ) : null}
          </div>

          {/*<div className="field-wrapper">*/}
          {/*  <label for="UploadOption" className="spacer-margin5">*/}
          {/*    Do you want to add or delete users?*/}
          {/*  </label>*/}
          {/*  <select*/}
          {/*    className="form-control w-lg4 spacer-inline"*/}
          {/*    name="UploadOption"*/}
          {/*    onChange={(el) => {*/}
          {/*      setAnswer("UploadOption", el.target.value);*/}
          {/*    }}*/}
          {/*    value={answers?.UploadOption}*/}
          {/*  >*/}
          {/*    <option value="Add">Add</option>*/}
          {/*    <option value="Delete">Delete</option>*/}
          {/*  </select>*/}
          {/*</div>*/}
          {/*Select CSV File*/}
          <div className="field-wrapper">
            <label for="UserFileUpload">Select CSV file</label>
            <div className="form-group">
              <input
                type="file"
                className="form-control-file  cblu-clr "
                id="UserSubmitFile"
                onChange={(el) => {
                  triggerValidation(el);
                }}
                //value={answers?.UserSubmitFile}
              />
            </div>
            {errFlag ? (
              <div className="alert alert-danger">
                The file you are trying to upload is not a CSV file. Please try
                again using a proper file type with a .csv file extension. You
                can also download our template and view our sample below.
              </div>
            ) : null}
            {answers?.UserSubmitFile === "" && submitFlag ? (
              <div className="alert alert-danger">CSV file is required.</div>
            ) : null}

            {/*<div className="alert alert-danger">*/}
            {/*  A file with the same name already exists. Please upload using a*/}
            {/*  new filename.*/}
            {/*</div>*/}
            <aside className="filelist-items">
              <p>
                The MS Excel spreadsheet must be saved as a CSV format that
                contains a .csv extension and rename the file if you intend to
                upload it again.
              </p>
              If a duplicate Username is entered, a unique number will be added
              to the Username (i.e. DrSmith - DrSmith1).
            </aside>
          </div>
          {/*Email Notify Flag*/}
          <div className="field-wrapper">
            <label>Email Notifications:</label>
            <input
              className="form-control"
              EmailNotification
              type="checkbox"
              onChange={(el) => {
                setAnswer("isSendNotification", el.target.checked);
              }}
              value={answers?.isSendNotification}
            />
            <aside className="filelist-items">
              If selected, a confirmation email will be sent to the provided
              contact email address for each successfully created account,
              containing the user's ID and a temporary password. If not
              selected, new users created during the upload process will not
              receive their account information and will be unable to access the
              site and webmail.
            </aside>
          </div>
          {errCreateMsg ? (
            <div
              className={`alert alert-danger`}
              dangerouslySetInnerHTML={{ __html: errMsg }}
            />
          ) : null}
          {processing ? <div className="loading"></div> : null}
          {/*Upload Action*/}
          <div className="button-register-container text-size4">
            <button
              type="button"
              className="btn btn-success "
              onClick={(e) => UploadFile()}
              disabled={errFlag}
            >
              Upload
            </button>
            <Link
              type="button"
              className="btn btn-outline-secondary spacer-margin9"
              to="/Users"
            >
              {successFlag ? "Close" : "Cancel"}
            </Link>
          </div>

          {/*User helpful templates */}
          <div className="box-template">
            <a
              href="javascript:void(0);"
              onClick={(el) => downTemplate("/users/DownloadCsvTemplate")}
              className="btn btn-primary box-containers box-sentmsg"
            >
              <div className="box-icon">
                <i className="bi bi-download"></i>
              </div>
              <div className="box-bottom">
                <div className="title">CSV File Template</div>
              </div>
            </a>
            <a
              href="https://www.nucc.org/index.php?option=com_content&view=article&id=107&Itemid=132"
              target="_blank"
              className="btn btn-primary box-containers box-status"
              rel="noreferrer"
            >
              <div className="box-icon">
                <img
                  src={TaxonomyCodeIcon}
                  className="filter-white"
                  alt="Taxonomy Codes Icon"
                />
              </div>
              <div className="box-bottom">
                <div className="title">NUCC Taxonomy Codes</div>
              </div>
            </a>
            <Link
              //to={"/bulkUpload"}
              onClick={openImg}
              target="_blank"
              className="btn btn-primary box-containers box-reports"
              alt="Sample CSV Template Screenshot"
            >
              <div className="box-icon">
                <img
                  src={MonitorIcon}
                  className="filter-white"
                  alt="Monitor Screen Icon"
                />
              </div>
              <div className="box-bottom">
                <div className="title">
                  Sample <br />
                  CSV File Screenshots
                </div>
              </div>
            </Link>
          </div>
        </div>

        {/*Right Panel*/}
        <div className="right-panel-s1">
          {/*Requirement Rules*/}
          <div className="field-wrapper label-hd-divider">Requirements</div>
          <div className="field-wrapper">
            <div className="text-reg spacer-margin7">
              The following list of items are required and must be included in
              your file.
            </div>
            <ul className="filelist-items">
              <li>
                <span className="ft-wt blk-clr">User Type:</span> Always enter
                Professional with exact case and characters
              </li>
              <li>
                <span className="ft-wt blk-clr">First Name:</span> 20 character
                limit
              </li>
              <li>
                <span className="ft-wt blk-clr">Last Name:</span> 35 character
                limit
              </li>
              <li>
                <span className="ft-wt blk-clr">Contact Email:</span> Non Direct
                email address
              </li>
              <li>
                <span className="ft-wt blk-clr">Username:</span> Username to
                login to the system
              </li>
              <li>
                <span className="ft-wt blk-clr">Address 1:</span> 100 character
                limit
              </li>
              <li>
                <span className="ft-wt blk-clr">City:</span> 50 character limit
              </li>
              <li>
                <span className="ft-wt blk-clr">State:</span> State Abbreviation
                - 2 character limit - Uppercase Only
              </li>
              <li>
                <span className="ft-wt blk-clr">Zip Code:</span> 5 character
                limit
              </li>
              <li>
                <span className="ft-wt blk-clr">Phone Number:</span> Use
                xxxxxxxxxx format
              </li>
              <li>
                <span className="ft-wt blk-clr">Requested Direct Address:</span>
                Must include the full Direct Address including domain
              </li>
            </ul>
          </div>

          {/*Optional Rules*/}
          <div className="field-wrapper label-hd-divider">Optional</div>
          <div className="field-wrapper">
            <div className="text-reg spacer-margin7">
              The following list of items are your options to include in your
              file.
            </div>
            <ul className="filelist-items">
              <li>
                <span className="ft-wt blk-clr">Address 2:</span> 100 character
                limit
              </li>
              <li>
                <span className="ft-wt blk-clr">Prefix:</span> Enter Ms, Mr,
                Miss, Mrs, Dr, or Prof with exact case and characters
              </li>
              <li>
                <span className="ft-wt blk-clr">Credential:</span> Enter
                credential with case and characters (M.D. or MD, etc.) - If you
                have more than one credential, please insert a space in between
                the credentials.
              </li>
              <li>
                <span className="ft-wt blk-clr">Fax Number:</span> Use
                xxxxxxxxxx format
              </li>
              <li>
                <span className="ft-wt blk-clr">
                  NPI (National Provider ID):{" "}
                </span>
                Must be a 10 digit number (Use xxxxxxxxxx format)
              </li>
              <li>
                <span className="ft-wt blk-clr">License Number:</span> Medical
                License Number - If you have more than one Medical License,
                additional Licenses can be added within the portal. If you enter
                your License Number, State of License is required.
              </li>
              <li>
                <span className="ft-wt blk-clr">State of License:</span> State
                of Medical License - 2 character limit - Uppercase Only - If you
                enter your State of License, License Number is required.
              </li>
              <li>
                <span className="ft-wt blk-clr">NUCC Taxonomy:</span> Input the
                code found in the current version of the National Uniform Claim
                Committee Health Care Provider Taxonomy Code Set
              </li>
            </ul>
          </div>
        </div>
      </form>
    </div>
  );
};

export default FormUserUpload;
